var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#fff}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    style: {
      fill: "#7c2b8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 0C90.5 0 59.2 14 36.6 36.6l176.8 176.8C236 190.8 250 159.5 250 125 250 56 194 0 125 0z",
    style: {
      fill: "#6e137d"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m192 110.4 1.2-6.3h-18.7l5.9-28.8h-8.6l-5.9 28.8h-17.3l5.9-28.8h-8.6l-5.9 28.8h-18.3l-1.2 6.3h18.2l-4.3 21.3h-18l-1.2 6.3H133l-5.6 27.6h8.6l5.6-27.6h17.3l-5.6 27.6h8.6l5.6-27.6h19.1l1.2-6.3h-19l4.3-21.3H192zm-31.9 21.3h-17.3l4.3-21.3h17.3l-4.3 21.3zM62.6 75.3h-5.7v99.4h11.5v-43.9h34.9v-11.6H68.4V86.8h38V75.3h-38z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f#.d2240ba8b378add07d2c462644e53c18.svg";
export { ForwardRef as ReactComponent };